import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useNetworkStore } from './store/networkStore';
import { useSettingsStore } from './store/settingsStore';
import { useKeyboardInput } from './game/InputHandler';
import { TouchControls } from './components';

import MainMenu from './screens/MainMenu';
import Lobby from './screens/Lobby';
import WaitingRoom from './screens/WaitingRoom';
import Game from './screens/Game';
import Results from './screens/Results';
import TrackEditor from './screens/TrackEditor';

function App() {
  const connect = useNetworkStore(state => state.connect);
  const room = useNetworkStore(state => state.room);
  const loadSettings = useSettingsStore(state => state.loadFromStorage);

  useEffect(() => {
    // Load settings from local storage
    loadSettings();
    
    // Connect to server
    connect();
  }, [connect, loadSettings]);

  // Initialize keyboard input
  useKeyboardInput();

  const showTouchControls = room && (room.state === 'racing' || room.state === 'countdown');

  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<MainMenu />} />
        <Route path="/lobby" element={<Lobby />} />
        <Route path="/room/:roomId" element={<WaitingRoom />} />
        <Route path="/game/:roomId" element={<Game />} />
        <Route path="/results/:roomId" element={<Results />} />
        <Route path="/admin" element={<TrackEditor />} />
        <Route path="/admin/:trackId" element={<TrackEditor />} />
      </Routes>
      {showTouchControls && <TouchControls />}
    </div>
  );
}

export default App;
